export default __webpack_public_path__ + "static/media/legs-2-v2.70a7c165.png";